import { STATS, STATS_read } from "@/data/permission-types.js";

export const stats = {
  id: `${STATS}`,
  name: "Statistik",
  disabled: false,
  info: "",
  icon: "mdi-chart-box",
  children: [
    {
      id: `${STATS_read}`,
      name: "Veranstaltungen",
      disabled: false,
      chipsName: "Veranstaltungen",
      info: "",
      icon: "",
      children: [
        //   {
        //     id: `${SCHEDULING_EVENTS_create}`,
        //     name: "Veranstaltungen erstellen",
        //     disabled: false,
        //     chipsName: "Terminplanung > Veranstaltungen (Erstellen)",
        //     info: "",
        //     icon: "mdi-plus-circle",
        //   },
        //   {
        //     id: `${SCHEDULING_EVENTS_read}`,
        //     name: "Veranstaltungen lesen",
        //     disabled: false,
        //     chipsName: "Terminplanung > Veranstaltungen (Lesen)",
        //     info: "",
        //     icon: "mdi-eye-circle",
        //   },
        //   {
        //     id: `${SCHEDULING_EVENTS_update}`,
        //     name: "Veranstaltungen bearbeiten",
        //     disabled: false,
        //     chipsName: "Terminplanung > Veranstaltungen (Bearbeiten)",
        //     info: "",
        //     icon: "mdi-pencil-circle",
        //   },
        //   {
        //     id: `${SCHEDULING_EVENTS_delete}`,
        //     name: "Veranstaltungen löschen",
        //     disabled: false,
        //     chipsName: "Terminplanung > Veranstaltungen (Löschen)",
        //     info: "",
        //     icon: "mdi-delete-circle",
        //   },
      ],
    },
  ],
};
